const controller = function (
	$scope,
	$rootScope,
	$filter,
	$ionicLoading,
	$ionicPlatform,
	$ionicScrollDelegate,
	$ionicPopup,
	$ionicModal,
	$state,
	$window,
	$timeout,
	Invoice,
	$auth,
	Customer,
	api,
	Affiliate,
) {
	'ngInject'

	var vm = this;

	vm.invoices = [];
	vm.scope = undefined;
	
	function initialize() {
		$ionicLoading.show();
		vm.affiliates = Affiliate.list;

		if (Boolean(Customer.session())) {
			vm.scopes = [
				{ value: 'session', display: $filter('ucfirst')($filter('translate')('session')) }
			];
		} else {
			vm.scopes = [
				{ value: 'today', display: $filter('ucfirst')($filter('translate')('today')) },
				{ value: 'yesterday', display: $filter('ucfirst')($filter('translate')('yesterday')) },
				{ value: 'thisweek', display: $filter('ucfirst')($filter('translate')('thisweek')) },
				{ value: 'previousweek', display: $filter('ucfirst')($filter('translate')('previousweek')) },
				{ value: 'thismonth', display: $filter('ucfirst')($filter('translate')('thismonth')) },
				{ value: 'previousmonth', display: $filter('ucfirst')($filter('translate')('previousmonth')) }
			];
		}
		
		if (vm.scope === undefined) {
			vm.scope = vm.scopes[0];
		}
		vm.session = Customer.get();
		Invoice.all(vm.scope.value).then(res => {
			vm.invoices = res.data;
			vm.opens = 0;
			vm.invoices.forEach(function(invoice) {
				invoice.total = _.reduce(invoice.products, (mem, item) => mem + item.product.price, 0);
				invoice.groups = _.groupBy(invoice.products, (item) => item.product_id);
				if (!((invoice.saved === 1 && invoice.printed === 1) || invoice.sent === 1 || invoice.cancelled === 1)) {
					vm.opens++;
				}
			});
		}).finally(() => {
			$ionicLoading.hide();
		});
	}

	vm.scopeChanged = () => {
		initialize();
	}

	vm.save = function($event, id) {
		$event.stopPropagation();
		$ionicLoading.show();
		Invoice.save(id).then(() => {
			initialize();
		}).catch(() => {
			$ionicPopup.alert({
				title: $filter('translate')('error_title'),
				subTitle: $filter('translate')('error_paragraph'),
				okType: 'button-assertive'
			});
		}).finally(() => {
			$ionicLoading.hide();
		});
	}

	vm.send = function($event, id) {
		$event.stopPropagation();
		$ionicLoading.show();
		Invoice.send(id).then(() => {
			initialize();
		}).catch(() => {
			$ionicLoading.hide();
			$ionicPopup.alert({
				title: $filter('translate')('error_title'),
				subTitle: $filter('translate')('error_paragraph'),
				okType: 'button-assertive'
			});
		}).finally(() => {
			$ionicLoading.hide();
		});
	}

	vm.print = function($event, id) {
		$event.stopPropagation();
		var url = api+'/v1/invoice/print/'+id+'?token='+localStorage.getItem('satellizer_token');
		if (window.cordova) {
			$ionicLoading.show();
			$ionicPlatform.ready(() => {
				cordova.plugins.printer.print(url, {}, res => {
					initialize();
				});
			});
		} else {
			$window.open(url, '_blank');
		}
	}


	vm.go = function(id) {
		$state.go('tab.details', {
			id: id
		});
	}

	vm.cancel = function($event, id, csid) {
		$event.stopPropagation();
		var doCancel = function(revert) {
			$ionicLoading.show();
			Invoice.cancel(id, revert).then(() => {
				initialize();
			}).catch(() => {
				$ionicPopup.alert({
					title: $filter('translate')('error_title'),
					subTitle: $filter('translate')('error_paragraph'),
					okType: 'button-assertive'
				});
			}).finally(() => {
				$ionicLoading.hide();
			});
		}
		$ionicPopup.show({
			title: $filter('ucfirst')($filter('translate')('invoice_cancel_confirm_title')),
			subTitle: $filter('translate')('invoice_cancel_confirm_paragraph'),
			buttons: [
				{
					text: $filter('ucfirst')($filter('translate')('cancel'))
				},
				{
					text: $filter('ucfirst')($filter('translate')('continue')),
					type: 'button-assertive',
					onTap: e => {
						if (Customer.session() && (Customer.session().id === csid)) {
							$ionicPopup.show({
								title: $filter('ucfirst')($filter('translate')('invoice_cancel_revert_title')),
								subTitle: $filter('translate')('invoice_cancel_revert_paragraph'),
								buttons: [
									{
										text: $filter('ucfirst')($filter('translate')('no')),
										onTap: e => {
											doCancel(false);
										}
									},
									{
										text: $filter('ucfirst')($filter('translate')('yes')),
										type: 'button-assertive',
										onTap: e => {
											doCancel(true);
										}
									}
								]
							});
						} else {
							doCancel(false);
						}
					}
				}
			]
		});
	}

	vm.toggleEssent = () => {
		Customer.update(vm.session.id, {
			essent: vm.session.essent
		});
	}

	vm.toggleZiggo = () => {
		Customer.update(vm.session.id, {
			ziggo: vm.session.ziggo
		});
	}

	vm.end = () => {

		var affiliates = Affiliate.list;

		if (affiliates && affiliates.length) {
			affiliates = affiliates.filter(affiliate => affiliate.enabled).map(affiliate => affiliate.id);
			if (affiliates.length) {
				Affiliate.push({
					customer_session_id: vm.session.id,
					affiliates
				})
			}
		}

		$scope.modal = $ionicModal.fromTemplate('<evaluation modal="modal"></evaluation>', {
			scope: $scope,
			animation: 'slide-in-up',
			backdropClickToClose: false,
			hardwareBackButtonClose: false
		});
		$scope.modal.show();
	}

	$scope.$on('$ionicView.enter', e => {
		initialize();
	});

	$scope.$on('CUSTOMER_CHANGED', () => {
		if ($auth.isAuthenticated()) {
			vm.scope = undefined;
			initialize();
		}
	});
}

export default controller


// WEBPACK FOOTER //
// ./app/components/invoices/overview/overview.controller.js